import { render } from "./WelcomeModal2.vue?vue&type=template&id=2e77fb81&scoped=true&ts=true"
import script from "./WelcomeModal2.vue?vue&type=script&lang=ts"
export * from "./WelcomeModal2.vue?vue&type=script&lang=ts"

import "./WelcomeModal2.vue?vue&type=style&index=0&id=2e77fb81&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e77fb81"],['__file',"src/components/modals/start/WelcomeModal2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e77fb81"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e77fb81', __exports__)) {
    api.reload('2e77fb81', __exports__)
  }
  
  module.hot.accept("./WelcomeModal2.vue?vue&type=template&id=2e77fb81&scoped=true&ts=true", () => {
    api.rerender('2e77fb81', render)
  })

}


export default __exports__